import { render, staticRenderFns } from "./PropertyRating.vue?vue&type=template&id=6143dc92"
import script from "./PropertyRating.vue?vue&type=script&lang=ts"
export * from "./PropertyRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports